import PropTypes from "prop-types";
import "./Modal.scss"; // SCSS for custom styles

const Modal = ({ isOpen, onClose, header, size = "large", children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={`modal-content ${size}`}>
        <div className="modal-header">
          <h2>{header}</h2>
          <span onClick={onClose} className="modal-close-button">
            ❌
          </span>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  children: PropTypes.node.isRequired,
};

// Removed defaultProps and used default parameter in the function signature instead

export default Modal;
